module.exports = __webpack_public_path__ + "img/p7.3518720b.png";